define('plugin/membership/collection/ClientMembershipCollection',['require','lib/collection/ServerPaginatedCollection','plugin/membership/model/ClientMembershipModel'],function (require) {

    // var BaseCollection = require('lib/collection/BaseCollection');
    var ServerPaginatedCollection = require('lib/collection/ServerPaginatedCollection');
    var ClientMembershipModel = require('plugin/membership/model/ClientMembershipModel');

    /**
     * Membership collection
     *
     * @class MembershipCollection
     */
    return ServerPaginatedCollection.extend({

        url: '/ext/membership/client-paginated',
        model: ClientMembershipModel

    });

});
